import {Component, OnInit, inject} from '@angular/core';
import {HupSubscriptionsService} from '../../data/services/hup-subscriptions.service';
import {TranslationService} from '../../core/services/translation.service';
import {HupSubscription} from '../../data/models/subscription.model';
import {NavigationCommand, NavigationService} from '../../data/services/navigation.service';
import {ConfigService} from '../../core/services/config.service';

@Component({
  selector: 'app-revocation',
  templateUrl: './revocation.component.html',
  styleUrls: ['./revocation.component.scss']
})
export class RevocationComponent implements OnInit {
  private hupSubscriptionsService = inject(HupSubscriptionsService);
  private navigationService = inject(NavigationService);
  private configService = inject(ConfigService);
  translationService = inject(TranslationService);

  isLoadingSub = false;
  subs: HupSubscription[] = [];
  errorsArr: string[] = [];

  protected isRevocable(sub: HupSubscription): boolean {
    if (sub.offer?.offerType?.ePaper) {
      return false;
    }
    // Für Print-Abos: Widerruf nur innerhalb von 14 Tagen ab Startdatum
    const startDate = sub.validDate?.validFrom ? new Date(sub.validDate.validFrom) : null;
    if (!startDate) {
      return false;
    }
    const cutoff = new Date(startDate);
    cutoff.setDate(startDate.getDate() + 14);
    const today = new Date();
    return today <= cutoff;
  }

  ngOnInit(): void {
    this.isLoadingSub = true;
    this.hupSubscriptionsService.getSubscriptions().subscribe({
      next: subs => {
        this.isLoadingSub = false;
        // Hinweis (Backport version/2.0): Das 7.0-Modell filterte hier zusätzlich
        // sub.subscriptionStatus !== 'IN_REVOCATION'. Das v2.0-HupSubscription-Modell
        // kennt dieses Feld nicht. Bereits laufende Widerrufe werden serverseitig über
        // HTTP 409 (revocation_already_exists) in revocation-edit abgefangen.
        this.subs = subs.filter(sub =>
          (sub.validDate.validUntil == null || sub.validDate.validUntil > new Date()) &&
          sub.backendId > 0 &&
          this.isRevocable(sub)
        );
        if (this.subs.length === 1) {
          this.onNewRevocation(this.subs[0]);
        }
      },
      error: () => {
        this.isLoadingSub = false;
        this.errorsArr.push(this.translationService.getTranslation('error_subscription_init'));
      }
    });
  }

  onNewRevocation(sub: HupSubscription): void {
    this.navigationService.navigateTo(NavigationCommand.REVOCATIONNEW, [sub.webId + '', sub.backendId + '']);
  }
}
